import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Copy } from 'lucide-react';
import { Button } from '../../../../components/ui/Button';
import { DjayNarrator } from '../../../../mascot';
interface SuccessStepProps {
  formSuccess: string;
  generatedCode: string;
  onAddAnother: () => void;
  onComplete: () => void;
}
export function SuccessStep({
  formSuccess,
  generatedCode,
  onAddAnother,
  onComplete
}: SuccessStepProps) {
  const [copied, setCopied] = useState(false);
  const copyToClipboard = () => {
    navigator.clipboard.writeText(generatedCode);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return <motion.div key="success" initial={{
    opacity: 0,
    scale: 0.95
  }} animate={{
    opacity: 1,
    scale: 1
  }} exit={{
    opacity: 0,
    scale: 0.95
  }} transition={{
    duration: 0.3,
    type: 'spring',
    bounce: 0.4
  }} className="max-w-lg mx-auto text-center py-4" data-id="element-8602">
      <div className="mb-6 flex justify-center" data-id="element-8603">
        <DjayNarrator size="lg" emotion="celebrating" data-id="element-8604" />
      </div>

      <h3 className="text-2xl font-black text-slate-900 mb-2" data-id="element-8605">Gelukt!</h3>
      <p className="text-lg text-slate-600 mb-8" data-id="element-8606">{formSuccess}</p>

      {generatedCode && <div className="bg-indigo-50 p-6 rounded-2xl border-2 border-indigo-100 mb-8" data-id="element-8607">
          <p className="text-xs font-bold text-indigo-800 uppercase tracking-wider mb-4" data-id="element-8608">
            Koppelcode voor de leerling
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3" data-id="element-8609">
            <div className="bg-white border-2 border-indigo-200 px-6 py-3 rounded-2xl font-mono text-3xl font-black tracking-widest text-indigo-900 shadow-sm" data-id="element-8610">
              {generatedCode}
            </div>
            <button onClick={copyToClipboard} className="p-3 bg-indigo-600 rounded-xl text-white hover:bg-indigo-700 transition-all focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:outline-none" title="Kopieer code" data-id="element-8611">
              {copied ? <CheckCircle2 className="w-6 h-6" data-id="element-8612" /> : <Copy className="w-6 h-6" data-id="element-8613" />}
            </button>
          </div>
          {copied && <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} className="text-sm font-bold text-emerald-600 mt-3" data-id="element-8614">
              ✓ Gekopieerd!
            </motion.p>}
          <p className="text-xs text-indigo-600 mt-4" data-id="element-8615">
            Deel deze code met de leerling of ouder om in te loggen.
          </p>
        </div>}

      <div className="flex flex-col sm:flex-row gap-3 justify-center" data-id="element-8616">
        <Button variant="secondary" onClick={onAddAnother} data-id="element-8617">
          Nog een toevoegen
        </Button>
        <Button onClick={onComplete} className="bg-slate-900 hover:bg-slate-800 text-white" data-id="element-8618">
          Klaar
        </Button>
      </div>
    </motion.div>;
}